import { useState } from "react";
import { api } from "../lib/api";
import { Search as SearchIcon, Loader2 } from "lucide-react";

export function SearchPage() {
  const [query, setQuery] = useState("");
  const [answer, setAnswer] = useState("");
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  async function ask() {
    if (!query.trim() || loading) return;
    setLoading(true);
    setError("");
    setAnswer("");
    try {
      const res = await api.query(query.trim());
      setAnswer(res.answer);
    } catch (e: any) {
      setError(e.message);
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="px-4 pt-4 pb-28">
      <h1 className="text-xl font-bold mb-4">Спросить Cortex</h1>

      <div className="relative mb-4">
        <SearchIcon
          size={18}
          className="absolute left-3 top-1/2 -translate-y-1/2 text-white/40"
        />
        <input
          value={query}
          onChange={(e) => setQuery(e.target.value)}
          onKeyDown={(e) => e.key === "Enter" && ask()}
          placeholder="Что я говорил про проект X?"
          className="w-full bg-surface-card border border-white/10 rounded-xl py-3 pl-10 pr-4 text-sm outline-none focus:border-accent/50"
        />
      </div>

      <button
        onClick={ask}
        disabled={loading || !query.trim()}
        className="w-full bg-accent hover:bg-accent-soft disabled:opacity-40 text-white font-medium py-3 rounded-xl mb-6 transition"
      >
        {loading ? (
          <span className="inline-flex items-center gap-2">
            <Loader2 size={18} className="animate-spin" /> Думаю...
          </span>
        ) : (
          "Спросить"
        )}
      </button>

      {error && (
        <div className="bg-red-500/10 text-red-300 text-sm rounded-xl p-4 mb-4">
          {error}
        </div>
      )}

      {answer && (
        <div className="bg-surface-card border border-white/5 rounded-xl p-4 text-sm leading-relaxed whitespace-pre-wrap">
          {answer}
        </div>
      )}
    </div>
  );
}